import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
export const routes: Routes = [
  { path: '', redirectTo: 'pages/login', pathMatch: 'full' },
  { path: 'pages/lockscreen', redirectTo: 'pages/lockscreen' },
  { path: 'pages/page-404', redirectTo: 'pages/page-404' },
  { path: '**', redirectTo: 'pages/page-404' }
];
export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { enableTracing: false, useHash: true });


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/app.routing.ts